module.exports = __webpack_public_path__ + "img/fish-chowder.67efdef9.jpg";